import { client } from '../client';
import { UserProfile } from './types/UserProfile';

type UpdateDivisionPayload = {
  division_ids: string[];
};

export const updateUserDivision = async (
  user_id: number,
  payload: UpdateDivisionPayload,
  userRole?: string,
): Promise<UserProfile> => {
  const prefix =
    userRole === 'CareAdvisor' ? '/care_advisor' : userRole === 'Collector' ? '/collector' : '/admin';
  const { data } = await client.patch(`${prefix}/users/${user_id}/divisions`, payload);

  return data;
};
